module.exports = __webpack_public_path__ + "static/img/7a.217bb33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7a.jpg
// module id = bw53
// module chunks = 0